import { DatePicker, FileUpload, InputField, MLInputField, MLTextArea } from '@/components/Exporter'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useTranslation } from 'react-i18next'
import placeholderImg from '@/assets/images/placeholders/doctor-placeholder.png'
import { Image } from '@/components/crRender'
import ImgProfile from './ImgProfile'



const PersonalInfo = ({ formHandler, handleProfileImageChange, data, profileImage }) => {
    const { t } = useTranslation()



    return (
        <div className="form-section">
            <div className="section-header">
                <Icon icon="mdi:account-circle" className="section-icon" />
                <h2>{t('personal-contact-information')}</h2>
            </div>

            <div className="section-content">
                <ImgProfile logo={data?.files || []} value={profileImage} formHandler={formHandler} setValue={handleProfileImageChange} />


                <div className="row">
                    <MLInputField defaultValue={data} name="doctorName" formHandler={formHandler} isLoading={false} isRequired />

                    <InputField defaultValue={data?.email} isRequired={false} lang={"En"} type={"email"} name="email" formHandler={formHandler} isLoading={false} />
                    <InputField defaultValue={data?.phoneNumber} isRequired={false} type={"number"} name="phoneNumber" formHandler={formHandler} isLoading={false} />
                    <DatePicker
                        name="birthDate"
                        formHandler={formHandler}
                        minDate={1900}
                        maxDate={new Date().getFullYear() - 26}
                        isSingle
                        defaultValue={data?.birthDate}
                        placeholder={t('birthDate')}
                        isLoading={false} isRequired />


                    <MLTextArea defaultValue={data} name="bio" formHandler={formHandler} />

                </div>
            </div>
        </div>

    )
}

export default PersonalInfo